import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actionRoute } from '../redux/actions';
import { selectRouteSimple } from '../redux/selectors';
import { routeDataGet } from '../utils/routes-helper';

const Breadcrumbs = (props) => {
  const dispatch = useDispatch();
  const routeSimple = useSelector(selectRouteSimple);
  let route = routeSimple.route;
  let breadcrumbs = routeSimple.breadcrumbs;

  let clicked = (what) => {
    return () => {
      dispatch(actionRoute(what))
    };
  }

  let jsxBreadcrumbs = [];
  // push home segment
  jsxBreadcrumbs.push(
    <span key={'key0HOME'} className="breadcrumbs-item clickable" onClick={clicked('HOME')}><i className="fa fa-home"></i> Početna</span>
  );
  // push other segment
  breadcrumbs.forEach((item, index) => {
    if (item !== 'HOME') {
      jsxBreadcrumbs.push(
        <span key={index + 'a'} className="breadcrumbs-delimeter">&gt;</span>
      );
      let routeData = routeDataGet(item);
      jsxBreadcrumbs.push(
        <span key={index + 'b'} className="breadcrumbs-item clickable" onClick={clicked(item)}>{routeData.title}</span>
      );
    }
  });

  return (
    <>
      <div className="breadcrumbs">
        {jsxBreadcrumbs}
      </div>
    </>
  );
};

export default Breadcrumbs;

/*
  return (
    <>
      <div className="breadcrumbs"><span className="breadcrumbs-item clickable" onClick={clicked('HOME')}><i className="fa fa-home"></i> Početna</span><span className="breadcrumbs-delimeter">&gt;</span><span className="breadcrumbs-item">Strana 1</span></div>
    </>
  );
*/
